import { BRAND_FONT_FAMILY, BRAND_WORDMARK } from "../../constants/brand";

const ACCENT_STYLES = {
  /** Landing / marketing navbar */
  solid: { className: "text-[#6366F1]" },
  /** Auth screens — indigo → violet gradient */
  gradient: {
    className: "text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-violet-600",
  },
  /** Footer on dark background */
  footer: {
    style: {
      background: "linear-gradient(69.35deg, #4F46E5 0%, #7C3AED 50%, #6366F1 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
  },
};

/**
 * Single source of truth for the JobScribe wordmark casing and font.
 * Parent page fonts (e.g. `font-sans`) must not change how the brand reads.
 */
export default function BrandWordmark({
  accent = "solid",
  className = "",
  prefixClassName = "",
}) {
  const accentProps = ACCENT_STYLES[accent] || ACCENT_STYLES.solid;

  return (
    <span
      className={className}
      style={{ fontFamily: BRAND_FONT_FAMILY }}
    >
      <span className={prefixClassName}>{BRAND_WORDMARK.prefix}</span>
      <span className={accentProps.className} style={accentProps.style}>
        {BRAND_WORDMARK.accent}
      </span>
    </span>
  );
}
